"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_SETTINGS_DASHBOARD_GROUPS = void 0;
exports.appSettingsRowsByApp = appSettingsRowsByApp;
const app_settings_database_1 = require("./app-settings-database");
const app_settings_engine_1 = require("./app-settings-engine");
const app_settings_tables_1 = require("./app-settings-tables");
/** Every Config table stands in exactly one group. */
exports.APP_SETTINGS_DASHBOARD_GROUPS = [
    {
        key: 'app',
        scope: 'app',
        tables: [
            'apps',
            'files',
            'exports',
            'navigation',
            'commands',
            'commandFields',
            'commandInputBindings',
            'commandNewRowFields',
        ],
    },
    { key: 'pages', scope: 'app', tables: ['routes', 'buildingBlocks'] },
    { key: 'tables', scope: 'app', tables: ['resources'] },
    {
        key: 'agentActions',
        scope: 'app',
        tables: ['agentActions', 'agentActionBindings', 'agentActionLookupKeys'],
    },
    { key: 'access', scope: 'app', tables: ['routeTableAccess'] },
    {
        key: 'container',
        scope: 'container',
        tables: [
            'container',
            'containerPages',
            'containerNavigation',
            'sourceFiles',
        ],
    },
    {
        key: 'containerTables',
        scope: 'container',
        tables: [
            'databaseBindings',
            'pendingDatabaseAttachments',
            'pendingDatabaseAttachmentColumns',
            'mounts',
            'mountBindings',
        ],
    },
    {
        key: 'containerAccess',
        scope: 'container',
        tables: [
            'pageAccess',
            'pageAccessTables',
            'pageAccessGroups',
            'pageAccessRefresh',
        ],
    },
    {
        key: 'compiled',
        scope: 'compiled',
        tables: app_settings_tables_1.APP_SETTINGS_TABLES.filter(table => (0, app_settings_database_1.isCompiledAppSettingsTable)(table.key)).map(table => table.key),
    },
];
/**
 * The rows of the App tables per App row, found over the `:parent` cell of
 * each row up to its row in `apps`. Tables without rows of an App are left
 * out; a row whose parent is missing throws, it is no row of these settings.
 */
function appSettingsRowsByApp(rows) {
    const model = (0, app_settings_tables_1.appSettingsModel)();
    const byTable = new Map(Object.entries(rows).map(([tableKey, tableRows]) => [
        tableKey,
        new Map(tableRows.map(row => [row.id, row])),
    ]));
    const appOf = (tableKey, row) => {
        let key = tableKey;
        let current = row;
        while (key !== 'apps') {
            const parentTable = model.table(key).parent;
            const parent = current.cells[app_settings_engine_1.SETTINGS_PARENT_COLUMN];
            const parentId = Array.isArray(parent) && parent.length === 1 ? parent[0] : undefined;
            const parentRow = parentTable && parentId !== undefined
                ? byTable.get(parentTable)?.get(parentId)
                : undefined;
            if (!parentTable || !parentRow)
                throw new app_settings_engine_1.SettingsMappingError(`Row ${row.id} of ${tableKey} has no parent row up to its App`);
            key = parentTable;
            current = parentRow;
        }
        return current.id;
    };
    const result = new Map();
    for (const [tableKey, tableRows] of Object.entries(rows)) {
        if (!(0, app_settings_database_1.isAppSettingsTableOfApp)(tableKey) ||
            (0, app_settings_database_1.isCompiledAppSettingsTable)(tableKey))
            continue;
        for (const row of tableRows) {
            const appId = appOf(tableKey, row);
            const tables = result.get(appId) ?? {};
            (tables[tableKey] ??= []).push(row);
            result.set(appId, tables);
        }
    }
    return result;
}
